export enum SummaryDataTest {
  DATA_STORED_CUSTOMER = "DATA_STORED_CUSTOMER",
  SUMMARY_HEADER_CUSTOMER = "SUMMARY_HEADER_CUSTOMER",
  SUMMARY_CONTAINER = "SUMMARY_CONTAINER",
  SUMMARY_TITLE = "SUMMARY_TITLE",
  SUMMARY_ANSWER = "SUMMARY_ANSWER",
  SUMMARY_QUESTION = "SUMMARY_QUESTION",
}
    